<div class="modal-header">
  <h4 class="modal-title"> Duplicate SKU Data </h4>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="activeModal.dismiss()"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-md-12">
      <button
        class="btn btn-outline-primary btn-sm mb-3 float-right"
        (click)="download()"
      >
        <i class="icon fas fa-file-export"></i>
        <span class="text">Export Duplicate SKU</span>
      </button>
      <table class="table table-hover table-dark">
        <thead>
          <tr>
            <th>ID</th>
            <th>Sku</th>
            <th>Type</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let r of skuRecord; let i = index">
            <tr (click)="r.is_show = !r.is_show" class="bg-info clickable">
              <td colspan="3">
                <h5
                  >{{ r.sku == '' ? '[Null]' : '[' + r.sku + ']' }} :
                  {{ r.count }} records found</h5
                >
              </td>
            </tr>
            <ng-container *ngIf="r.is_show">
              <tr class="bg-light text-dark" *ngFor="let sku of r.data">
                <td
                  ><strong>{{ sku.id }}</strong></td
                >
                <td>{{ sku.sku }}</td>
                <td
                  ><div class="badge badge-primary">{{ sku.type }}</div></td
                >
              </tr>
            </ng-container>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>
<div class="modal-footer"> </div>
